import React from "react";
import {GERMAN} from "../actions/language";
import {LanguageContext} from "../context/LanguageContext";
import {
    BUSINESS_IDENTIFICATION_NUMBER,
    BUSINESS_NAME_WITH_POSTFIX, OFFICE_CONTACT_EMAIL,
    OFFICE_CONTACT_OFFICE_PHONE_NUMBER,
    OFFICE_LOCATION_PLACE,
    OFFICE_LOCATION_STREET, VALUE_ADDED_TAX_IDENTIFICATION
} from "../env";

export default class Impressum extends React.Component {
    static contextType = LanguageContext;

    render() {
        const { language } = this.context;

        return (
            <div className="container fancy-paragraph">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h2 className="fancy-title p-standard-top mt-5">
                            <b>
                                {language === GERMAN ? 'Impressum' : 'Impressão'}
                            </b>
                        </h2>
                    </div>
                    <div className="fancy-paragraph">
                        <div className="fancy-card-2 shadow p-4">
                            <p>
                                <b>
                                    {language === GERMAN
                                        ? 'Angaben gemäß § 5 TMG'
                                        : 'Informação de acordo com o § 5 TMG:'}
                                </b>
                            </p>
                            <p>{BUSINESS_NAME_WITH_POSTFIX}, <br/> {OFFICE_LOCATION_STREET}, <br/> {OFFICE_LOCATION_PLACE}</p>
                            <p>
                                <b>{language === GERMAN ? 'Vertreten durch:' : 'Representado por:'}</b>
                                <br/>
                                Jorge Manuel Marques Gomes Tomé & Manuel Paulino Varela Martins
                            </p>
                            <p>
                                <b>{language === GERMAN ? 'Kontakt:' : 'Contacto:'}</b>
                                <br/>
                                {language === GERMAN ? 'Telefon:' : 'Telefone:'} {OFFICE_CONTACT_OFFICE_PHONE_NUMBER}
                                <br/>
                                E-Mail: {OFFICE_CONTACT_EMAIL}
                            </p>
                            <p>
                                <b>
                                    {language === GERMAN
                                        ? 'Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:'
                                        : 'Número de identificação do imposto sobre o valor acrescentado em conformidade com o § 27a da Lei do Imposto sobre o Valor Acrescentado:'}
                                </b>
                                <br/>
                                {VALUE_ADDED_TAX_IDENTIFICATION}
                            </p>
                            <p>
                                <b>
                                    {language === GERMAN
                                        ? 'Wirtschafts-Identifikationsnummer gemäß § 139c Abgabenordnung:'
                                        : 'Número de identificação comercial de acordo com o § 139c do Código Fiscal Alemão:'}
                                </b>
                                <br/>
                                {BUSINESS_IDENTIFICATION_NUMBER}
                            </p>
                            <p>
                                <b>
                                    {language === GERMAN
                                        ? 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:'
                                        : 'Responsável pelo conteúdo de acordo com o § 55 Abs. 2 RStV:'}
                                </b>
                                <br/>
                                Can Dogan, <br/> {OFFICE_LOCATION_STREET}, <br/> {OFFICE_LOCATION_PLACE}
                            </p>
                            <div className="fancy-disclaimer mt-4">
                                <p>
                                    <b>
                                        {language === GERMAN
                                            ? 'Haftungsausschluss (Disclaimer):'
                                            : 'Exclusão de responsabilidade (declaração de exoneração de responsabilidade):'}
                                    </b>
                                    <br/>
                                    {language === GERMAN
                                        ? 'Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Dennoch übernimmt Tome & Martins GbR keine Haftung für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Informationen. Haftungsansprüche gegen Tome & Martins GbR, die sich auf Schäden materieller oder immaterieller Art beziehen, die durch die Nutzung der angebotenen Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens Tome & Martins GbR kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.'
                                        : 'O conteúdo deste sítio Web foi compilado com o maior cuidado possível. No entanto, a Tome & Martins GbR não assume qualquer responsabilidade pela exatidão, integridade e atualidade das informações fornecidas. As reclamações de responsabilidade contra a Tome & Martins GbR relativas a danos materiais ou imateriais causados pela utilização da informação disponibilizada estão fundamentalmente excluídas, exceto se houver prova de dolo ou negligência grave por parte da Tome & Martins GbR.'}
                                </p>
                            </div>
                            <div className="fancy-disclaimer mt-4">
                                <p>
                                    <b>
                                        {language === GERMAN
                                            ? 'Urheberrecht:'
                                            : 'Direitos de autor:'}
                                    </b>
                                    <br/>
                                    {language === GERMAN
                                        ? 'Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Dennoch übernimmt Tome & Martins GbR keine Haftung für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Informationen. Haftungsansprüche gegen Tome & Martins GbR, die sich auf Schäden materieller oder immaterieller Art beziehen, die durch die Nutzung der angebotenen Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens Tome & Martins GbR kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.'
                                        : 'O conteúdo deste sítio Web foi compilado com o maior cuidado possível. No entanto, a Tome & Martins GbR não assume qualquer responsabilidade pela exatidão, integridade e atualidade das informações fornecidas. As reclamações de responsabilidade contra a Tome & Martins GbR relativas a danos materiais ou imateriais causados pela utilização da informação disponibilizada estão fundamentalmente excluídas, exceto se houver prova de dolo ou negligência grave por parte da Tome & Martins GbR.'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Impressum.js